




















































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import Reference from "../../../interfaces/uniabc/Reference";
import { dispatchDeleteReference } from "../../../store/uniabc/actions";
import { readReferencesOfLabel } from "@/store/uniabc/getters";
import EditReference from "@/components/editor/references/EditReference.vue";

@Component({
  components: { EditReference }
})
export default class LocalReferenceList extends Vue {
  @Prop(String) readonly label!: string;
  @PropSync("recomputeRefs", { type: Number }) updateRefs!: number;

  public origRefs?: Reference[] = readReferencesOfLabel(this.$store)(
    this.label || ""
  );

  private refSearch = "";

  // get references() {
  //     this.updateRefs
  //     return Object.keys(this.origRefs ?? {}).map(
  //         r => this.origRefs![r]
  //     );
  // }

  private referenceHeaders = [
    { text: "Key", value: "key" },
    { text: "Reference", value: "reference" },
    { text: "Text", value: "text" },
    { text: "RefType", value: "reftype" },
    { text: "Edit", value: "edit" }
  ];

  private async deleteReference(ref: Reference) {
    await dispatchDeleteReference(this.$store, {
      label: this.label,
      ref: ref
    });

    this.updateRefs++;
  }

  get refs() {
    return this.origRefs;
  }
}
